"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var CalendarIcon = function () {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 0H5V2H3V0ZM6 1H10V3H14V1C15.1046 1 16 1.89543 16 3V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V3C0 1.89543 0.895431 1 2 1V3H6V1ZM2 5H14V14H2V5ZM6 7V9H4V7H6ZM7 7H9V9H7V7ZM12 9V7H10V9H12ZM6 10V12H4V10H6ZM9 10H7V12H9V10ZM10 12V10H12V12H10ZM13 0H11V2H13V0Z", fill: "#2362A2" })));
};
exports.default = CalendarIcon;
